export const TRUSTEE_TABLE_REPORT = [
  { label: 'First Name', key: 'trusteeFirstName' },
  { label: 'Middle Name', key: 'trusteeMiddleName' },
  { label: 'Last Name', key: 'trusteeLastName' },
  { label: 'Email', key: 'emailAddress' },
  { label: 'Type', key: 'trusteeType' },
  { label: 'Status', key: 'status' }
];

export const GUARDIAN_TABLE_REPORT = [
  { label: 'First Name', key: 'guardianFirstName' },
  { label: 'Middle Name', key: 'guardianMiddleName' },
  { label: 'Last Name', key: 'guardianLastName' },
  { label: 'Email', key: 'emailAddress' },
  { label: 'Type', key: 'guardianType' },
  { label: 'Status', key: 'status' }
];

export const EXECUTORS_TABLE_REPORT = [
  { label: 'First Name', key: 'executorFirstName' },
  { label: 'Middle Name', key: 'executorMiddleName' },
  { label: 'Last Name', key: 'executorLastName' },
  { label: 'Email', key: 'emailAddress' },
  { label: 'Type', key: 'executorType' }
];

export const BENEFICIARY_TABLE_REPORT = [
  { label: 'First Name', key: 'beneficiaryFirstName' },
  { label: 'Middle Name', key: 'beneficiaryMiddleName' },
  { label: 'Last Name', key: 'beneficiaryLastName' },
  { label: 'Email', key: 'emailAddress' },
  { label: 'Relationship', key: 'relationship' },
  { label: 'Status', key: 'status' }
];

export const SPOUSE_TABLE_REPORT = [
  { label: 'First Name', key: 'spouseFirstName' },
  { label: 'Middle Name', key: 'spouseMiddleName' },
  { label: 'Last Name', key: 'spouseLastName' },
  { label: 'Email', key: 'emailAddress' },
  { label: 'Phone Number', key: 'phoneNumber' },
  { label: 'Status', key: 'status' }
];

export const CHILDREN_TABLE_REPORT = [
  { label: 'First Name', key: 'childFirstName' },
  { label: 'Middle Name', key: 'childMiddleName' },
  { label: 'Last Name', key: 'childLastName' },
  { label: 'Phone Number', key: 'phoneNumber' },
  { label: 'Gender', key: 'gender' },
  { label: 'Status', key: 'status' }
];

export const CUSTOMER_TABLE_REPORT = [
  { label: 'First Name', key: 'othername' },
  { label: 'Last Name', key: 'surname' },
  { label: 'Email', key: 'email' },
  { label: 'Product Bought', key: 'productBought' },
  { label: 'Date', key: 'createdAt' }
];

export const PROSPECT_TABLE_REPORT = [
  { label: 'First Name', key: 'othername' },
  { label: 'Last Name', key: 'surname' },
  { label: 'Type', key: 'type' },
  { label: 'Prospect ID', key: 'prospect_id' },
  { label: 'Date', key: 'date' }
];
